import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=3b9bb4cc&scoped=true&"
import script from "./Information.ts?vue&type=script&lang=ts&"
export * from "./Information.ts?vue&type=script&lang=ts&"
import style0 from "./Information.vue?vue&type=style&index=0&id=3b9bb4cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9bb4cc",
  null
  
)

export default component.exports